<div class="login my-auto">
  <mat-card class="login-card my-4">
    <h2 translate>LOGIN.TITLE</h2>
    <mat-card-content>
      <form ngNoForm action="/sign_in" method="post" class="login-form">
        <mat-form-field appearance="fill">
          <mat-label translate>LABEL.EMAIL</mat-label>
          <input matInput name="user[email]" id="email-input" />
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label translate>LABEL.PASSWORD</mat-label>
          <input matInput type="password" name="user[password]" id="password-input" />
        </mat-form-field>
        <a class="forgot-password mt-2" routerLink="/forgot-password" translate>LOGIN.FORGOT_PASSWORD</a>
        <input type="hidden" [name]="csrfParam" [value]="csrfToken" />
        <input type="hidden" name="after_sign_in_path" [value]="afterSignInPath$ | async" />
        <input type="hidden" name="language" [value]="selectedLanguage" />
        <div class="button-container text-center">
          <button class="mb-2" mat-raised-button type="submit" color="primary">
            <span translate>LOGIN.BUTTON</span>
          </button>
          <a class="signup-link" mat-stroked-button routerLink="/signup" translate>
            <span translate>LOGIN.SIGNUP</span>
          </a>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
